// Mapping centralisé des erreurs 429 (rate limiting) vers un message français.
// Isolé dans son propre module (sans dépendance à axios) pour être testable
// et réutilisable sans charger tout le client API.

/**
 * Construit un message français pour une réponse HTTP 429, jamais le
 * « Too Many Attempts. » brut de Laravel. Si le backend fournit un délai
 * (en-tête `Retry-After` ou champ `retry_after`), il est reformulé en clair.
 */
export const getThrottleMessage = (
  err: any,
  fallback = 'Trop de tentatives. Veuillez patienter quelques minutes avant de réessayer.'
): string => {
  const headers = err?.response?.headers ?? {};
  const rawDelay = headers['retry-after'] ?? headers['Retry-After'] ?? err?.response?.data?.retry_after;
  const retryAfter = Number(rawDelay);

  if (Number.isFinite(retryAfter) && retryAfter > 0) {
    if (retryAfter > 90) {
      const minutes = Math.ceil(retryAfter / 60);
      return `Trop de tentatives. Vous pourrez réessayer dans ${minutes} minute${minutes > 1 ? 's' : ''}.`;
    }
    const seconds = Math.max(1, Math.round(retryAfter));
    return `Trop de tentatives. Veuillez réessayer dans ${seconds} seconde${seconds > 1 ? 's' : ''}.`;
  }

  // Le limiter nommé « register » renvoie déjà un message FR : on le réutilise,
  // sauf s'il s'agit du message brut anglais d'un autre limiter non personnalisé.
  const backendMsg = err?.response?.data?.message;
  if (typeof backendMsg === 'string' && backendMsg && !/too many attempts/i.test(backendMsg)) {
    return backendMsg;
  }
  return fallback;
};
